import { useQuery } from '@apollo/client/react/hooks';
import { gql } from '@yi/core';

export function useUserCourseProgressById(id: string) {
  const { data, loading, error } = useQuery<
    gql.typesClient.Query_CurrentUser_CoursesProgress,
    gql.typesClient.Query_CurrentUser_CoursesProgressVariables
  >(gql.Query_CurrentUser_CoursesProgress, {
    ssr: false,
    variables: {
      ids: [id],
    },
    context: {
      batch: true,
    },
  });

  return {
    activity: data?.CurrentUserCourses?.[0] || null,
    loading,
    error,
  };
}
